import styled from "styled-components";

export const MusicaWrapper = styled.div``;

export const MusicaTitle = styled.h2``;

export const MusicaSubTitle = styled.h3``;
